export default __webpack_public_path__ + "static/media/about11.572b92ab.jpeg";